/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createNode } from '../../factoriesAny.js';
export var NodeDependencies = {
  createNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesNode.generated.js
// module id = 54
// module chunks = 2